import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { ResolvedRocResults } from '../../dto';
// import { QueryType } from '../../helpers/query';
import { ReqVars } from './common';

export type ROCVariables = { userId: number; limit: number; offset: number; rocTypeIds: number[] };
export type ROCResults = { user: { resolvedRocs: ResolvedRocResults }};

const query = gql`

  query getResolvedRocs($userId: Int!, $limit: Int, $offset: Int, $rocTypeIds: [Int!]) {
    user(id: $userId) {
      resolvedRocs(limit: $limit, offset: $offset, rocTypeIds: $rocTypeIds) {
        columns
        rocTypes {
          id
          name {
            text
          }
          sortIndex
          form {
            id
          }
        }
        rocs {
          rocId
          formSubId
          values {
            column
            value
          }
          date
          typeId
          contactedBy
        }
        rocsCount
      }
    }
  }
`;

export const useRecordOfContacts = (options: ReqVars<QueryHookOptions<ROCResults, ROCVariables>>) => useQuery<ROCResults, ROCVariables>(query, options);

export default useRecordOfContacts;
